module.exports = __webpack_public_path__ + "img/pic-4.6794ad57.png";